import { GetOneCustomerInDto, GetOneCustomerOutDto } from '../../../types/customer.dto'

export const GET_ONE_CUSTOMER = 'GET_ONE_CUSTOMER'
export const GET_ONE_CUSTOMER_SUCCESS = 'GET_ONE_CUSTOMER_SUCCESS'
export const GET_ONE_CUSTOMER_ERROR = 'GET_ONE_CUSTOMER_ERROR'
export const RESET_GET_ONE_CUSTOMER = 'RESET_GET_ONE_CUSTOMER'

export interface GetOneCustomer {
  type: typeof GET_ONE_CUSTOMER
  payload: GetOneCustomerOutDto
}

export interface GetOneCustomerSuccess {
  type: typeof GET_ONE_CUSTOMER_SUCCESS
  payload: GetOneCustomerInDto
}

export interface GetOneCustomerError {
  type: typeof GET_ONE_CUSTOMER_ERROR
  payload: string | boolean
}

export interface ResetGetOneCustomer {
  type: typeof RESET_GET_ONE_CUSTOMER
  payload: null
}

export interface State {
  data: GetOneCustomerInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetOneCustomer | GetOneCustomerSuccess | GetOneCustomerError | ResetGetOneCustomer
